/**
 * Featured Collections Section - OLD theme compatibility for 2.0
 * Initializes Flickity carousels and tab switching (1:1 with OLD theme behavior)
 */
(function() {
  if (window.__featuredCollectionsInitLoaded) return;
  window.__featuredCollectionsInitLoaded = true;
  var FLICKITY_CDN = 'https://unpkg.com/flickity@2.3.0/dist/flickity.pkgd.min.js';
  var LAP_AND_UP = '(min-width: 1008px)';

  function matchesLapAndUp() {
    return window.matchMedia && window.matchMedia(LAP_AND_UP).matches;
  }

  function getSiblings(el, selector) {
    var siblings = [];
    var parent = el.parentNode;
    if (!parent) return siblings;
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i] !== el && (!selector || children[i].matches && children[i].matches(selector))) {
        siblings.push(children[i]);
      }
    }
    return siblings;
  }

  function initFeaturedCollectionsSection(container) {
    if (!container || container.dataset.featuredCollectionsInit === 'true') return;
    container.dataset.featuredCollectionsInit = 'true';

    var options = {};
    try {
      options = JSON.parse(container.getAttribute('data-settings') || '{}');
    } catch (e) {}

    var carousels = [];
    var flickityElements = container.querySelectorAll('[data-flickity-config]');

    function createCarousel(el) {
      if (!window.Flickity) return null;
      try {
        var config = JSON.parse(el.getAttribute('data-flickity-config') || '{}');
        config.transitionDuration = config.transitionDuration || 280;
        config.selectedAttraction = config.selectedAttraction || 0.15;
        config.friction = config.friction || 0.75;
        var flkty = new Flickity(el, config);
        return { element: el, flickity: flkty, destroy: function() { flkty.destroy(); } };
      } catch (e) {
        return null;
      }
    }

    function initCarousels() {
      carousels.forEach(function(c) {
        if (c && c.destroy) c.destroy();
      });
      carousels = [];
      flickityElements = container.querySelectorAll('[data-flickity-config]');
      for (var i = 0; i < flickityElements.length; i++) {
        var c = createCarousel(flickityElements[i]);
        if (c) carousels.push(c);
      }
    }

    function switchTab(target) {
      if (!target || target.classList.contains('is-active')) return;

      target.classList.add('is-active');
      getSiblings(target, '.is-active').forEach(function(item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      target.setAttribute('aria-selected', 'true');

      var panelId = target.getAttribute('aria-controls');
      var tabPanelToShow = panelId ? container.querySelector('#' + panelId) : null;
      if (!tabPanelToShow) return;

      getSiblings(tabPanelToShow, '.TabPanel').forEach(function(panel) {
        panel.setAttribute('aria-hidden', 'true');
      });
      tabPanelToShow.setAttribute('aria-hidden', 'false');

      if (matchesLapAndUp()) {
        carousels.forEach(function(c) {
          if (c && c.flickity) {
            if (typeof c.flickity.activate === 'function') c.flickity.activate();
            if (typeof c.flickity.resize === 'function') c.flickity.resize();
          }
        });
      }
    }

    function handleTabClick(e) {
      var target = e.target.closest('[data-action="toggle-tab"]');
      if (target) {
        e.preventDefault();
        switchTab(target);
      }
    }

    container.addEventListener('click', handleTabClick);

    function loadFlickityAndInit() {
      if (window.Flickity) {
        initCarousels();
        return;
      }
      var script = document.createElement('script');
      script.src = FLICKITY_CDN;
      script.async = true;
      script.onload = function() {
        initCarousels();
      };
      document.head.appendChild(script);
    }

    loadFlickityAndInit();

    container._featuredCollectionsCleanup = function() {
      container.removeEventListener('click', handleTabClick);
      carousels.forEach(function(c) {
        if (c && c.destroy) c.destroy();
      });
      container.dataset.featuredCollectionsInit = '';
      delete container._featuredCollectionsCleanup;
    };
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-section-type="featured-collections"], [data-section-type="related-products"]');
    for (var i = 0; i < sections.length; i++) {
      initFeaturedCollectionsSection(sections[i]);
    }
  }

  function destroySection(container) {
    if (container && container._featuredCollectionsCleanup) {
      container._featuredCollectionsCleanup();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function(e) {
    var container = e.target;
    if (!container) return;
    var section = container.querySelector ? container.querySelector('[data-section-type="featured-collections"], [data-section-type="related-products"]') : null;
    if (!section && container.getAttribute && (container.getAttribute('data-section-type') === 'featured-collections' || container.getAttribute('data-section-type') === 'related-products')) {
      section = container;
    }
    if (section) destroySection(section);
  });

  document.addEventListener('shopify:section:load', function(e) {
    var container = e.target;
    if (!container) return;
    var section = container.querySelector ? container.querySelector('[data-section-type="featured-collections"], [data-section-type="related-products"]') : null;
    if (!section && container.getAttribute && (container.getAttribute('data-section-type') === 'featured-collections' || container.getAttribute('data-section-type') === 'related-products')) {
      section = container;
    }
    if (section) initFeaturedCollectionsSection(section);
  });
})();
